import { Center, Image, Spinner } from '@chakra-ui/react';

import useFetchFileDownloadUrl from 'app/hooks/useFetchFileDownloadUrl';

import { PresetThumbnailProps } from './types';

/**
 * Renders a savings preset image by its file-upload id, resolving the image via the
 * file-processing download URL. Shows a spinner while resolving and a neutral box if it can't.
 */
function PresetThumbnail({ imageId, fileName, size = '56px' }: PresetThumbnailProps) {
  const { data: imageUrl, isInitialLoading } = useFetchFileDownloadUrl(imageId, fileName);

  return (
    <Center
      w={size}
      h={size}
      bg="brand.lightGray2"
      borderRadius="8px"
      overflow="hidden"
      flexShrink={0}
    >
      {isInitialLoading ? (
        <Spinner size="sm" color="brand.purple" />
      ) : (
        imageUrl && (
          <Image
            src={imageUrl}
            alt={fileName ?? 'Savings preset'}
            objectFit="cover"
            w="full"
            h="full"
            loading="lazy"
            decoding="async"
          />
        )
      )}
    </Center>
  );
}

export default PresetThumbnail;
